/* eslint camelcase: "off" */

import BaseAdapter from 'Core/adapters/base';

class PromotionCodeAdapter extends BaseAdapter {
  static get(code, price) {
    let requestParams = {
      params: {
        code: code,
        price: price
      }
    };

    return this.prototype.getRequest('/checkout/promotion', requestParams);
  }
}

export default PromotionCodeAdapter;
